<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!eliminazioneInCorso"
  [dismissableMask]="!eliminazioneInCorso"
  [style]="{width: '500px', maxWidth: '100vw'}"
  styleClass="p-fluid conferma-eliminazione-file-dialog"
  [showHeader]="false"
  (onHide)="onHide()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-trash header-icon"></i>
        <h2>Conferma Eliminazione File</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="eliminazioneInCorso"
        (click)="onHide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content" *ngIf="intervento">
      <div class="flex justify-content-center mb-3">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
      </div>

      <h3>Sei sicuro di voler eliminare tutti i file di questa rendicontazione?</h3>

      <div class="warning-message">
        <i class="pi pi-info-circle"></i>
        <span>Questa azione non può essere annullata e rimuoverà tutti i documenti associati a questa specifica rendicontazione.</span>
      </div>
      <div class="intervento-info">
        <p-divider></p-divider>
        <div class="info-row">
          <div class="info-label">Intervento:</div>
          <div class="info-value">
            <span class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
              <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice }}</span>
            </span>
          </div>
        </div>

        <div class="info-row" *ngIf="intervento?.richiesta?.anno">
          <div class="info-label">Anno:</div>
          <div class="info-value">{{ intervento.richiesta.anno }}</div>
        </div>

        <div class="info-row" *ngIf="intervento?.scheda?.descrizione">
          <div class="info-label">Descrizione:</div>
          <div class="info-value">{{ intervento.scheda.descrizione }}</div>
        </div>

        <div class="info-row" *ngIf="rendicontazione">
          <div class="info-label">Rendicontazione:</div>
          <div class="info-value">
            <span class="badge" [ngClass]="{
              'badge-acconto': rendicontazione.tipo.descrizione === 'ACCONTO',
              'badge-saldo': rendicontazione.tipo.descrizione === 'SALDO'
            }">
              {{ rendicontazione.tipo.descrizione }}
            </span>
            - {{ rendicontazione.importo | currency:'EUR':'':'1.2-2':'it-IT' }}
          </div>
        </div>

        <div class="info-row" *ngIf="rendicontazione && rendicontazione.creata">
          <div class="info-label">Data:</div>
          <div class="info-value">{{ rendicontazione.creata | date:'dd/MM/yyyy' }}</div>
        </div>
      </div>


    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        [disabled]="eliminazioneInCorso"
        (click)="annulla()">
      </button>
      <button
        pButton
        pRipple
        label="Elimina Tutti i File"
        icon="pi pi-trash"
        class="p-button-danger"
        [loading]="eliminazioneInCorso"
        (click)="confermaEliminazione()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Toast per messaggi -->
<p-toast position="top-right"></p-toast>
